var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('p',[_vm._v("Hello from PlantCharts")]),_c('div',[_c('ConsumptionAndWateringChart',{attrs:{"plant":_vm.getPlant}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }